import { mangaWorks } from '@/mocks/manga';
import MangaCard from '@/components/feature/MangaCard';

export default function NewReleases() {
  const latest = [...mangaWorks]
    .sort((a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime())
    .slice(0, 8);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6" id="new-releases">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-4xl font-bold text-foreground-900 font-heading mb-3">
              新作速递
            </h2>
            <p className="text-foreground-500 text-sm md:text-base">
              最新更新的优质作品，第一时间发现好内容
            </p>
          </div>
          <div className="flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
            <span className="text-xs text-accent-600 font-medium whitespace-nowrap">实时更新</span>
          </div>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {latest.map((work) => (
            <MangaCard key={work.id} {...work} />
          ))}
        </div>
      </div>
    </section>
  );
}